import React, { Component } from 'react';
import {
  Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb
} from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { debounce } from 'lodash';
import { companyCodeTitle } from '../../actions/root_url';
import { UI_HEIGHT } from '../Common/constants';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import checkPermission from '../Common/permissions';
import { numberWithCommas } from '../Common/numberWithCommas';
import {fetchShipToOrders} from "../../actions/shipToOrders_actions";
import {fetchShipFromOrders} from "../../actions/shipFromOrders_actions";
const {
  Draggable: {
    Container: DraggableContainer,
    RowActionsCell,
    DropTargetRowContainer,
  },
  Data: { Selectors },
} = require("react-data-grid-addons");

class PreOrder extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      breadcrumbTitle: 'ship_from_orders',
      tableHeight: window.innerHeight - UI_HEIGHT.fiveLineButton,
      shipFromOrders: {
        rows: [],
        selectedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      salesOrderDetail: {
        rows: [],
        selectedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      rowsCount: 0,
      total: 0,
      canceledOrders: 0,
      canceledTotal: 0,
    };

    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    window.console.log('componentDidMount');
    window.addEventListener('resize', this.handleResize);
    document.title = companyCodeTitle;
    this.props.fetchShipFromOrders();
  }

  componentWillUnmount() {
    window.console.log('componentWillUnmount');
    window.removeEventListener('resize', this.handleResize);
  }

  componentWillReceiveProps(nextProps) {
    window.console.log('componentWillReceiveProps', nextProps);
    if (
      nextProps.shipFromOrders &&
      nextProps.shipFromOrders !== this.props.shipFromOrders
    ) {
      // Split Weight
      if (
        this.state.shipFromOrders.selectedRows &&
        this.state.shipFromOrders.selectedRows.length === 1
      ) {
        nextProps.shipFromOrders.Orders.map((orders) => {
          if (orders.Shiporder_id === this.state.shipFromOrders.selectedRows[0].Shiporder_id) {
            this.state.shipFromOrders.selectedRows[0].FinalShippingWeight =
              orders.FinalShippingWeight;
          }
        });
      }
      this.setState({ total: nextProps.shipFromOrders.Rows });

      const shipFromOrders = {
        ...this.state.shipFromOrders,
        rows: nextProps.shipFromOrders.Orders,
        filters: {},
      };
      const selectedRows0 = shipFromOrders.selectedRows[0];
      if (selectedRows0) {
        for (let i = 0; i < shipFromOrders.rows.length; i++) {
          if (selectedRows0.Shiporder_id === shipFromOrders.rows[i].Shiporder_id) {
            shipFromOrders.rows[i].isSelected = true;
          }
        }
      }

      const salesOrderDetail = { ...this.state.salesOrderDetail, rows: [] };
      this.setState({ shipFromOrders, salesOrderDetail });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    window.console.log('shouldComponentUpdate', nextProps, nextState);
    return true;
  }

  componentDidUpdate(prevProps, prevState) {
    window.console.log('shouldComponentUpdate', prevProps, prevState);
    if (prevState.shipFromOrders !== this.state.shipFromOrders) {
      let canceledTotal = 0;
      const canceledOrders = this.state.shipFromOrders.rows.filter((row) => {
        const match = row.SaleStatus === "Canceled";
        if (match) {
          canceledTotal += row.FinalPrice;
        }
        return match;
      });
      this.setState({
        rowsCount: Data.Selectors.getRows(this.state.shipFromOrders).length,
        canceledOrders: canceledOrders.length,
        canceledTotal,
      });
    }
  }

  handleResize() {
    this.setState({
      tableHeight: window.innerHeight - UI_HEIGHT.fiveLineButton,
    });
  }

  // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
  renderTable() {
    const route = this.context.router.routes[1].path;
    // Parameters of the react-data-grid
    const tableHeight = window.innerHeight < 930 ? 270 : 270;
    const getRows = () => Data.Selectors.getRows(this.state.shipFromOrders);
    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      this.state.total = 0;
      for (let i = 0; i < rows.length; i++) {
        this.state.total += rows[i].FinalPrice;
      }
      return rows[rowIdx];
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.shipFromOrders, {
        sortColumn,
        sortDirection,
      });
      if (state.sortColumn === 'OrderDateDisplay') {
        state.sortColumn = 'OrderDate';
      }

      if (state.sortDirection === 'ASC') {
        this.state.pullSheetSort = state.sortColumn;
      } else if (state.sortDirection === 'DESC') {
        this.state.pullSheetSort = `-${state.sortColumn}`;
      } else {
        this.state.pullSheetSort = '';
      }
      this.setState({ shipFromOrders: state });
    };

    const handleFilterChange = debounce(
      (filter) => {
        this.state.total = 0;
        this.state.shipFromOrders.rows = this.props.shipFromOrders.Orders;
        this.state.shipFromOrders.selectedRows = [];
        const newFilters = Object.assign({}, this.state.shipFromOrders.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        const shipFromOrders = { ...this.state.shipFromOrders, filters: newFilters };
        this.setState({ shipFromOrders });
      },
      500,
      { maxWait: 800 },
    );

    // Handle the row select function
    const onRowClick = (rowIdx, row) => {
      if (rowIdx !== -1) {
        const rows = getRows();
        /* Multi row select on row click
          let selectedRows = [...this.state.shipFromOrders.selectedRows];

          let id = rows[rowIdx].SalesOrder_id;
          let idx = selectedRows.indexOf(id);
          if (idx == -1) {
            rows[rowIdx].isSelected = true;
            selectedRows.push(id);
          } else {
            rows[rowIdx].isSelected = false;
            selectedRows.splice(idx, 1);
          }
        */

        /* Single row select on row click */
        rows.map((r) => {
          r.isSelected = false;
        });
        const selectedRows = [rows[rowIdx]];
        rows[rowIdx].isSelected = true;

        const shipFromOrders = { ...this.state.shipFromOrders, rows, selectedRows };
        this.setState({ shipFromOrders });
        // this.props.fetchSalesOrderDetail(row.SalesOrder_id, route);
      }
    };

    // Custom Formatter component

    const DateFormatter = React.createClass({
      render() {
        if (this.props.value) {
          // const dateMap = [
          //   'Jan',
          //   'Feb',
          //   'Mar',
          //   'Apr',
          //   'May',
          //   'Jun',
          //   'Jul',
          //   'Aug',
          //   'Sep',
          //   'Oct',
          //   'Nov',
          //   'Dec',
          // ];
          const date = new Date(this.props.value);
          // const index = dateMap.indexOf(date.toString().slice(4, 3));
          // const localDate = index + date.toString().slice(8, 6);
          return <span>{date.toString().slice(4, 15)}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });

    // Column difinition
    const columns = [
      {
        key: 'Order_Num',
        name: <Translate value="order_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
      },
      {
        key: 'Note',
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      },
      {
        key: 'PaaymentAmount',
        name: 'Payment Amount',
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: 'TotalPrice',
        name: 'Total Price',
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: 'file_path',
        name: 'File Path',
        resizable: true,
        sortable: true,
        width: 160,
        filterable: true,
      },
      {
        key: 'FBA_id',
        name: 'FBA ID',
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: 'OrderStatus',
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: 'PaymentStatus',
        name: <Translate value="payment_status" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: 'invoice_path',
        name: 'Invoice Path',
        resizable: true,
        sortable: true,
        width: 130,
        filterable: true,
      },
      {
        key: 'mailing_label',
        name: 'Mailing Label',
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: 'nonfba_address',
        name: 'Non FBA Address',
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: 'nonfba_recipientname',
        name: 'Non FBA Recipient Name',
        resizable: true,
        sortable: true,
        width: 150,
        filterable: true,
      },
      {
        key: 'nonfba_shipspeed',
        name: 'Non FBA Ship Speed',
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: 'nonfba_upload_additional_doc',
        name: 'Non FBA Upload Additional Doc',
        resizable: true,
        sortable: true,
        width: 160,
        filterable: true,
      },
      {
        key: 'warehouse_destination',
        name: 'Warehouse Destination',
        resizable: true,
        sortable: true,
        width: 105,
        filterable: true,
      },
      {
        key: 'request_time',
        name: 'Request Time',
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: 'create_time',
        name: 'Create Time',
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: DateFormatter,
      },
    ];

    const generateColumns = () => columns;
    return (
      // React Table Sales Order History Table
      <div id="TNMSOTable">
        <Row>
          <Col xs={12}>
            <div id="shipFromOrders-dataGrid1">
              <ReactDataGrid
                rowKey="Shiporder_id"
                ref={(g) => {
                  this.grid = g;
                }}
                onGridSort={handleGridSort}
                toolbar={<Toolbar enableFilter />}
                onAddFilter={handleFilterChange}
                columns={generateColumns()}
                rowHeight={25}
                headerRowHeight={45}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={tableHeight}
                enableRowSelect="multi"
                rowSelection={{
                  showCheckbox: true,
                  enableShiftSelect: true,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
                onRowClick={onRowClick}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div>
              <Col xs={2}>
                <label className="row-count">
                  <Translate value="total_orders" />
                  :&nbsp;
                  <span className="font-color-orange" id="row-count-equation">
                    {`${this.state.rowsCount} - ${
                        this.state.canceledOrders
                      } = ${this.state.rowsCount - this.state.canceledOrders}`}
                  </span>
                </label>
              </Col>
              <Col xs={6}>
                <label className="grand-total">
                  <span className="grand-total-label">
                    <Translate value="grand_total" />
                      :&nbsp;
                  </span>
                  <span className="font-color-grey" id="total-equation">
                    {`$${numberWithCommas((this.state.total || 0).toFixed(2))} - $${numberWithCommas((this.state.canceledTotal || 0).toFixed(2))} = $${numberWithCommas((this.state.total - this.state.canceledTotal).toFixed(2))}`}
                  </span>
                </label>
              </Col>
              <Col xs={4}>
                <div className="mso-footnotes">
                  <span>
                    <Translate value="msg_total_orders_equation" />
                  </span>
                  <span>
                    <Translate value="msg_grand_total_equation" />
                  </span>
                </div>
              </Col>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
  render() {
    return (
      //---------------
      // Begin HTML
      //---------------
      <ContentWrapper>
        {/* Nav Trail */}
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="sales_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value={this.state.breadcrumbTitle} />
          </Breadcrumb.Item>
        </Breadcrumb>{' '}
        {/* End Nav Trail */}
        <Grid id="sales-orders-list">
          <Row>
            <Col xs={12}>
              <Panel
                className="position-relative table-collapse-fix"
                id="table-collapse-fix-450"
                style={{ marginBottom: '0px' }}
              >
                {/* Sales Order Full Table */}
                {this.renderTable()}
              </Panel>
            </Col>
          </Row>{' '}
          {/* End Sales Order Full Table  */}
          {/* Sale Order Details */}
          <Row>
            <Col xs={12}>
              <h2>
                <Translate value="order_details" />
              </h2>
              <Panel className="details-table-collapse-fix">
                {/*{this.renderProductsTable()}*/}
              </Panel>
            </Col>
          </Row>{' '}
          {/* Sale Order Details */}
        </Grid>
      </ContentWrapper>
      //---------------
      // End HTML
      //---------------
    );
  }
}

export default PreOrder;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/shipFromOrders.jsx